import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const ModalConfirm = ({
  titleToShow,
  messageToShow,
  onClickHandler = () => {},
  onCancelHandler = () => {},
  onDidRender = () => {},
  onDidOpen = () => {},
  isShowConfirmButton = true,
  isShowCanceButton = true,
  isTimerModal = false,
  isShowCloseButton = false,
  textConfirmButton,
  textCancelButton,
  customClassContainer = "addedToCartRibola",
}) => {
  // modal sweetalert2
  const MySwal = withReactContent(Swal);

  let timerInterval;
  if (isTimerModal) {
    MySwal.fire({
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: titleToShow,
          }}
        />
      ),
      html: messageToShow,
      timer: 2000,
      timerProgressBar: true,
      showConfirmButton: isShowConfirmButton,
      showCancelButton: isShowCanceButton,
      allowOutsideClick: false,
      showCloseButton: isShowCloseButton,
      customClass: {
        container: customClassContainer,
        title: "titleRibola",
        htmlContainer: "htmlContainerRibola",
      },
      didOpen: () => {
        Swal.showLoading();
      },
      didRender: () => {
        if (onDidRender) {
          onDidRender();
        }
      },
      willClose: () => {
        clearInterval(timerInterval);
      },
    }).then((event) => {
      if (onClickHandler) {
        onClickHandler();
      } else {
        onCancelHandler();
      }
    });
  } else {
    MySwal.fire({
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: titleToShow,
          }}
        />
      ),
      html: messageToShow,
      confirmButtonText: textConfirmButton,
      cancelButtonText: textCancelButton,
      confirmButtonColor: "#004F91",
      cancelButtonColor: "#707070",
      showConfirmButton: isShowConfirmButton,
      showCancelButton: isShowCanceButton,
      allowOutsideClick: false,
      showCloseButton: isShowCloseButton,
      customClass: {
        container: customClassContainer,
        confirmButton: "confirmButtonRibola",
        cancelButton: "cancelButtonRibola",
        title: "titleRibola",
        htmlContainer: "htmlContainerRibola",
      },
      didOpen: () => {
        const customSwalBtnConfirm = document.querySelector(
          ".customSwalBtnConfirm"
        );
        if (customSwalBtnConfirm !== null) {
          customSwalBtnConfirm.addEventListener("click", function () {
            MySwal.clickConfirm();
          });
        }

        const customSwalBtnClose = document.querySelector(
          ".customSwalBtnClose"
        );
        if (customSwalBtnClose !== null) {
          customSwalBtnClose.addEventListener("click", function () {
            MySwal.close();
          });
        }
      },
      didRender: () => {
        if (onDidRender) {
          onDidRender();
        }
      },
    }).then((event) => {
      if (event.isConfirmed === true) {
        onClickHandler();
      } else {
        onCancelHandler();
      }
    });
  }

  return <div></div>;
};

export default ModalConfirm;
